import { z } from "zod";
import { messageTemplateSchema } from "@lendflow/schemas";

export const commentSchema = z.object({
  id: z.string(),
  content: messageTemplateSchema.optional(),
  is_resolved: z.boolean(),
  resolved_at: z.string().nullable(),
  commentable_type: z.string(),
  commentable_id: z.union([z.string(), z.number()]),
  created_at: z.string(),
});

export type Comment = z.infer<typeof commentSchema>;
